import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var AtSign = createReactComponent("AtSign", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "4",
  key: "7pwehp"
}], ["path", {
  d: "M16 8v5a3 3 0 006 0v-1a10 10 0 10-3.92 7.94",
  key: "13mccx"
}]]]);
export default AtSign;